import React from 'react';

import { RouteLayout } from 'shared/components/layouts';

import { GroupsContent } from '../components';

export const GroupsPage: React.FC = () => {
  return <RouteLayout content={<GroupsContent />} />;
};
